import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '@common/application/utils/classnames';
import { DImage } from '@common/components/common/image';
import { useTranslation } from 'next-i18next';
export const EmptyList = ({ className, imageClassName, text, customImage, customText }) => {
    const { t } = useTranslation(['common']);
    return (_jsxs("div", Object.assign({ className: classNames('w-full flex flex-col justify-center items-center', 'h-77', 'pc:h-101', className) }, { children: [_jsx(DImage, { className: classNames('w-75 h-42.5', 'mb-5', 'pc:mb-6', imageClassName), src: customImage }), _jsx("div", Object.assign({ className: "text-base text-black-1" }, { children: customText || t('emptyList', { name: text || '' }) }))] })));
};
